"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = void 0;
function parseUrl(url) {
    var _a, _b;
    const protocol = (_b = (_a = url.match(/^(.*?:)/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 'https:';
    const hostname = url
        .replace(protocol, '')
        .replace(/^\/*/, '')
        .split(/[\?\/]/)[0];
    return { protocol, hostname };
}
exports.parseUrl = parseUrl;
